// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34DBX","input":"styles_input__95V1t"};